import PropTypes from 'prop-types';

export default PropTypes.shape({
  imageUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  callToAction: PropTypes.string,
  detailsImageUrl: PropTypes.string,
  targetUrl: PropTypes.string,
  impressionTrackingUrls: PropTypes.arrayOf(PropTypes.string),
  detailsImpressionTrackingUrls: PropTypes.arrayOf(PropTypes.string),
  clickTrackingUrl: PropTypes.string,
});
